import {
  isComponentFormFieldTypeText,
  isComponentFormFieldTypeSelect,
  isComponentFormFieldTypeRadio,
  isComponentFormFieldTypeCheckbox,
  isComponentFormFieldTypeTextarea,
  isComponentFormFieldTypeHidden,
} from '~/services/origins/contentful';
import { adaptFieldCheckbox } from '~/services/origins/contentful/adapters/adaptFieldCheckbox';
import { adaptFieldHidden } from '~/services/origins/contentful/adapters/adaptFieldHidden';
import { adaptFieldRadio } from '~/services/origins/contentful/adapters/adaptFieldRadio';
import { adaptFieldSelect } from '~/services/origins/contentful/adapters/adaptFieldSelect';
import { adaptFieldText } from '~/services/origins/contentful/adapters/adaptFieldText';
import { adaptFieldTextarea } from '~/services/origins/contentful/adapters/adaptFieldTextarea';
import type { ContentfulFields } from '~/services/origins/contentful';
import type { FieldsSchema } from '~/shared/domain/models';

export const adaptFields = (fields: ContentfulFields[]): FieldsSchema[] => {
  const parsedFields = fields.reduce((acc, currentField) => {
    if (!currentField) {
      throw new Error('Missing or invalid field');
    }

    if (isComponentFormFieldTypeText(currentField)) {
      acc.push(adaptFieldText(currentField));
    } else if (isComponentFormFieldTypeSelect(currentField)) {
      acc.push(adaptFieldSelect(currentField));
    } else if (isComponentFormFieldTypeRadio(currentField)) {
      acc.push(adaptFieldRadio(currentField));
    } else if (isComponentFormFieldTypeCheckbox(currentField)) {
      acc.push(adaptFieldCheckbox(currentField));
    } else if (isComponentFormFieldTypeTextarea(currentField)) {
      acc.push(adaptFieldTextarea(currentField));
    } else if (isComponentFormFieldTypeHidden(currentField)) {
      acc.push(adaptFieldHidden(currentField));
    } else {
      throw new Error('Field type not implemented');
    }

    return acc;
  }, [] as FieldsSchema[]);

  return parsedFields;
};
